































import { Vue,Component,Prop,Watch } from "vue-property-decorator";
import { IBIZServiceBase } from '@/api'
import { IfuzzrySerach } from '@/interface'

@Component({})
export default class AppMenuSearch extends  Vue {

  public loading = true
  /**
  * 菜单服务对象 
  */
  @Prop()
  public service!:IBIZServiceBase

  /**
  *  检索关键字内容
  */
  public searchAllValue:string = ''

  /**
  *  返回内容 
  */
  public dropdownList:Array<IfuzzrySerach> = []
  
  /**
  * 下拉菜单样式处理,与搜索栏保持一致 
  */
  public dropDownStyle(){
    const el = document.getElementsByClassName('app-menu-search')[0] as HTMLDivElement;
    const dropdown = document.getElementsByClassName('menu-search')[0] as HTMLDivElement;
    if(dropdown){
      dropdown.style.width = el.offsetWidth - 10 + 'px'
      dropdown.style.left = '0px'
    }
  }

  /**
  * 检索栏过滤方法
  */
  public querySearch<T extends boolean|KeyboardEvent>(visible:T) {
    if(!visible){
      this.dropdownList = []
      return
    }
    if((visible as KeyboardEvent)?.code === 'Enter'){
      const dropdown = this.$refs.searchMenuDropdown;
      (dropdown as any).visible = true;
    }
    this.loading = true
    this.service.fuzzySearch(this.searchAllValue).then((res:any) => {
      this.dropdownList = res
      this.loading = false
      this.$forceUpdate()
    })
  }

  /**
  * 检索栏下拉选中方法
  */
  public handleSelect(item: IfuzzrySerach) {
    this.$emit('search-item-select', item);
  }

  /**
  * 关键字高亮
  */
  public highlighting(value: string) {
    if (this.searchAllValue) {
      return value.replace(
        new RegExp(this.searchAllValue, "g"),
        `<span class="tag">${this.searchAllValue}</span>`
      );
    } else {
      return value;
    }
  }


  mounted(){
    this.$nextTick(() => {
      this.dropDownStyle()
    })
  }
}
